<template>
  <div>
    <div class="mb-3">
      <div class="tab-header-option">
        <v-row class="ma-0">
        <v-col class="pa-0" :cols="12" :lg="6" :md="6" :sm="12">
          <v-col class="pa-0 tab-header-option-text">Live Question</v-col>
          <v-col class="pa-0 tab-subtitle-2 font-weight-thin"
            >การส่งคำถามที่เตรียมไว้ล่วงหน้าและส่งให้ผู้ชมตอบคำถามแบบเรียลไทม์</v-col
          >
        </v-col>
        <v-col class="pa-0 text-right" :cols="12" :lg="6" :md="6" :sm="12">
          <v-btn
            @click="initialize"
            class="pl-5 pr-5 xs-full-width font-weight-light btn-refresh"
            elevation="0"
            color="#d9d9d9"
            outlined
          >
            <v-icon left>mdi-cached</v-icon>
            <span class="text-refresh">{{
              $vuetify.lang.t('$vuetify.courseManagement.filterBar.refresh')
            }}</span>
          </v-btn>
          <v-btn
            color="#308AB7"
            dark
            @click="viewLeaderBoard"
            class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
          >
            <v-img
              src="@/assets/icon/leader_board.png"
              lazy-src="@/assets/icon/leader_board.png"
              max-width="17"
              class="mr-3"
            ></v-img
            >&nbsp; LEADER BOARD
          </v-btn>
        </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col :cols="12" :lg="4" :md="4" :sm="12" class="pt-0">
          <div class="header-option">
            <div class="tab-header-container pt-2">
              <v-row justify="space-between" class="ma-0">
                <v-col md="6" :cols="6" class="pr-0 pl-0 pb-0 pt-2">
                  <div class="tab-header-text">Pending Question</div></v-col
                >
                <v-col md="6" :cols="6" class="pa-0">
                  <div class="tab-header-text text-right">
                    <v-btn
                      elevation="0"
                      @click="editQuestion(null)"
                    >
                      <v-icon color="#308ab7">mdi-plus</v-icon>
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.liveStep.addQuestion'
                            )
                          }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>

            <div
              class="question-list-container"
              v-for="question in listQuestion"
              :key="question._id"
            >
              <div class="question-detail">
                <span class="question-no"
                  >ข้อที่ {{ question.priority }}.
                </span>
                <span class="question-list-text">{{ question.question }}</span>

                <v-img
                  :src="question.imageQuestion"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  v-if="question.imageQuestion !== null"
                />

                <div>
                  <v-spacer></v-spacer>
                  <v-row
                    class="ma-0 action-btn-container"
                    justify="space-between"
                  >
                    <v-col
                      :cols="12"
                      :lg="6"
                      :md="12"
                      :sm="12"
                      class="pa-0 align-center"
                    >
                      <v-btn
                        elevation="0"
                        class="text-capitalize font-weight-light button-primary btn-send full-btn"
                        :disabled="!valid"
                        small
                        @click="showTimeQuestion(question.id, question.time)"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.liveStep.addLiveDialog.send'
                          )
                        }}</v-btn
                      >
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col
                      :cols="12"
                      :lg="6"
                      :md="12"
                      :sm="12"
                      class="pa-0 d-flex place-content"
                    >
                      <!-- <v-btn
                    elevation="0"
                    class="ma-2 button-secondary font-weight-light text-capitalize btn-edit"
                    outlined
                    small
                    @click="editQuestion(question.id)"
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.liveStep.addLiveDialog.edit'
                      )
                    }}</v-btn
                  > -->

                      <!--  -->
                      <v-btn
                        elevation="0"
                        class="body-2 text-primary text-capitalize"
                        color="white"
                        @click="editQuestion(question.id)"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.liveStep.addLiveDialog.edit'
                            )
                          }}
                        </p>
                      </v-btn>
                      <v-divider inset vertical class="mb-2 mx-1"></v-divider>
                      <v-btn
                        elevation="0"
                        class="body-2 error--text text-capitalize"
                        color="white"
                        @click="openDeleteDialog(question.id)"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.liveStep.delete'
                            )
                          }}
                        </p>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <!--  -->
                </div>
              </div>
            </div>
            <div class="question-list-container">
              <div class="question-detail">
                <v-pagination
                  v-model="questionCurrPage"
                  class="pagination-align-right justify-flex-end"
                  :length="totalQuestionPage"
                ></v-pagination>
              </div>
            </div>
          </div>
        </v-col>
        <v-col :cols="12" :lg="8" :md="8" :sm="12" class="pt-0">
          <div class="header-option">
            <div class="tab-header-container">
              <div class="tab-header-text text-center">Question Report</div>
            </div>
          </div>
          <v-row class="header-table-report ma-0">
            <v-col
              :cols="1"
              :lg="1"
              :md="1"
              :sm="12"
              class="text-center header-cell-table-report"
            ></v-col>
            <v-col
              :cols="2"
              :lg="2"
              :md="2"
              :sm="12"
              class="text-left header-cell-table-report"
              >ข้อที่.
            </v-col>
            <v-col
              :cols="4"
              :lg="4"
              :md="4"
              :sm="12"
              class="text-left header-cell-table-report"
              >คำถาม</v-col
            >
            <v-col
              :cols="2"
              :lg="2"
              :md="2"
              :sm="12"
              class="text-center header-cell-table-report"
              >รูปภาพ</v-col
            >
            <v-col
              :cols="3"
              :lg="3"
              :md="3"
              :sm="12"
              class="text-center header-cell-table-report"
              >จำนวนการตอบ(คน)</v-col
            >
          </v-row>
          <div
            v-for="question of listQuestionReport"
            :key="question.id"
            :class="
              question.id == expandId
                ? 'content-table-report expand-panel-opt'
                : 'content-table-report'
            "
          >
            <v-row class="ma-0">
              <v-col
                :cols="1"
                :lg="1"
                :md="1"
                :sm="12"
                class="text-center cell-table-report"
              >
                <span class="question-no"
                  ><v-icon
                    @click="expand(question.id)"
                    v-if="question.id !== expandId"
                    color="#009bde"
                    >mdi-chevron-right</v-icon
                  >
                  <v-icon
                    @click="hide(question.id)"
                    v-if="question.id == expandId"
                    color="#009bde"
                    >mdi-chevron-down</v-icon
                  >
                </span></v-col
              >
              <v-col
                :cols="2"
                :lg="2"
                :md="2"
                :sm="12"
                class="text-left cell-table-report"
              >
                <span class="question-no"
                  >ข้อที่ {{ question.priority }}.
                </span></v-col
              >
              <v-col
                :cols="4"
                :lg="4"
                :md="4"
                :sm="12"
                class="text-left cell-table-report"
              >
                {{ question.question }}</v-col
              >
              <v-col
                :cols="2"
                :lg="2"
                :md="2"
                :sm="12"
                class="text-center cell-table-report pa-0"
                align-self="center"
              >
                <span v-if="!question.imageQuestion">-</span>
                <v-img
                  :src="question.imageQuestion"
                  max-width="40"
                  class="image-center"
                />
              </v-col>
              <v-col
                :cols="3"
                :lg="3"
                :md="3"
                :sm="12"
                class="text-center cell-table-report"
              >
                {{ question.totalAnswers }}/{{
                  question.totalParticipants
                }}</v-col
              >
            </v-row>
            <div v-if="question.id == expandId">
              <v-row class="subcontent-table-report ma-0">
                <v-col
                  :cols="1"
                  :lg="1"
                  :md="1"
                  :sm="12"
                  class="text-center cell-table-report"
                ></v-col>
                <v-col
                  :cols="11"
                  class="text-left cell-table-report question-no opt-ans"
                  >ตัวเลือกคำตอบ
                </v-col>
              </v-row>
              <v-row class="subcontent-table-report ma-0">
                <v-col
                  :cols="1"
                  :lg="1"
                  :md="1"
                  :sm="12"
                  class="text-center cell-table-report"
                ></v-col>
                <v-col
                  :cols="10"
                  class="text-left cell-table-report question-no"
                >
                  <v-row
                    v-for="(choice, index) in question.choices"
                    :key="index"
                  >
                    <v-col
                      :cols="choice.image ? 1 : 12"
                      :lg="choice.image ? 1 : 12"
                      :md="choice.image ? 1 : 12"
                      :sm="12"
                      class="align-center cell-table-report pt-0"
                      ><span class="choice-table-report"
                        >{{ index + 1 }}.
                        <span v-if="choice.text">{{ choice.text }}</span></span
                      ></v-col
                    >
                    <v-col
                      :cols="2"
                      :lg="2"
                      :md="2"
                      :sm="12"
                      v-if="choice.image"
                      class="text-center align-center cell-table-report pt-0"
                      ><v-img
                        :src="choice.image"
                        max-width="40"
                        class="image-center"
                    /></v-col>
                    <v-col
                      :cols="choice.image ? 5 : 8"
                      :lg="choice.image ? 5 : 8"
                      :md="choice.image ? 5 : 8"
                      :sm="12"
                      class="text-center align-center cell-table-report pt-0"
                    >
                      <v-progress-linear
                        :color="
                        choice.correct
                          ? 'success'
                          : 'error'
                      "
                        class="align-center"
                        :value="
                          choice.totalAnswersPercentage
                            ? choice.totalAnswersPercentage
                            : 0
                        "
                        :height="6"
                      ></v-progress-linear
                    ></v-col>
                    <v-col
                      :cols="2"
                      :lg="2"
                      :md="2"
                      :sm="12"
                      class="text-center align-center cell-table-report pt-0"
                      >{{
                        choice.totalAnswersPercentage
                          ? choice.totalAnswersPercentage
                          : 0
                      }}%</v-col
                    >
                    <v-col
                      :cols="2"
                      :lg="2"
                      :md="2"
                      :sm="12"
                      class="text-center align-center cell-table-report pt-0"
                    >
                      <v-btn
                        elevation="0"
                        class="ma-2 text-capitalize align-center font-weight-light button-primary btn-send"
                        small
                        @click="openListStudentAnsDialog(question.id, choice._id)"
                        >ตอบ {{ choice.totalAnswers }} คน</v-btn
                      ></v-col
                    >
                  </v-row>
                </v-col>
                <v-col
                  :cols="1"
                  :lg="1"
                  :md="1"
                  :sm="12"
                  class="text-center cell-table-report"
                ></v-col>
              </v-row>
            </div>
          </div>
          <div class="question-list-container">
            <div class="question-detail">
              <div>
              <v-pagination
                v-model="questionReportCurrPage"
                class="pagination-align-right justify-flex-end"
                :length="totalQuestionReportPage"
              ></v-pagination>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="dialogDelay" max-width="450">
      <v-card>
        <v-card-title class="headline">เวลาในการตอบคำถาม</v-card-title>

        <v-card-text class="pb-0">
          <v-row>
            <v-col>
              <p class="subtitle-1">
                เมื่อกดยืนยันแล้ว
                ผู้ชมถ่ายทอดสดจะสามารถตอบคำถามได้ในเวลาที่กำหนดเท่านั้น
              </p>
              <p class="subtitle-1">
                <strong class="font-weight-blod">หมายเหตุ</strong
                >&nbsp;สามารถกำหนดเวลาใหม่ได้ที่นี่
              </p>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="d-flex pa-0" cols="6">
              <v-text-field
                hide-details
                class="mx-3"
                type="number"
                v-model="mins"
                min="0"
                @change="checkMinMins"
                single-line
                outlined
              ></v-text-field>
              <v-spacer></v-spacer>
              <p class="subtitle-1 pt-3">นาที</p>
            </v-col>
            <v-col class="d-flex pa-0" cols="6">
              <v-text-field
                hide-details
                class="mx-3"
                type="number"
                min="0"
                max="59"
                v-model="secs"
                @change="checkMinSecs"
                single-line
                outlined
              ></v-text-field>
              <!-- <v-spacer></v-spacer> -->
              <p class="subtitle-1 pt-3">วินาที</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="mt-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            class="title"
            color="grey darken-1"
            large
            outlined
            @click="dialogDelay = false"
            >ยกเลิก</v-btn
          >

          <v-btn
            class="title"
            color="primary darken-1"
            large
            dark
            @click="sendQuizToLive"
            >ยืนยัน</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogViewReport"
      persistent
      scrollable
      max-width="600px"
    >
      <v-card class="overflow-hd">
        <v-toolbar flat class="mb-0">
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialogViewReport = false"
            >Close</v-btn
          >
        </v-toolbar>
        <v-card-text>
          <div class="q-report">
            <v-row>
              <v-col cols="12" class="pa-0 ml-3">
                <p class="font-weight-bold title mb-0">
                  Question {{ this.questionNumber + 1 }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-card flat tile>
                  <v-img
                    :src="
                      this.arrReportQuiz[0].quizImgQuestion == null ||
                      this.arrReportQuiz[0].quizImgQuestion == ''
                        ? imageReady
                        : this.arrReportQuiz[0].quizImgQuestion
                    "
                    :lazy-src="this.arrReportQuiz[0].quizImgQuestion"
                    aspect-ratio="1"
                    height="60"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-icon
                          v-if="imageReady"
                          class="mx-auto"
                          elevation="3"
                          size="60"
                          >mdi-image</v-icon
                        >
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
              <v-col cols="9">
                <p class="subtitle-1 font-weight-bold mb-0">
                  {{ this.arrReportQuiz[0].quizQuestion }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-card class="mx-auto">
                  <v-card-title>
                    <p class="subtitle-1 mb-0">Answered</p>
                    <v-spacer></v-spacer>
                    <span
                      :class="`headline font-weight-bold cyan--text`"
                      v-text="this.arrReportQuiz[0].countQuiz"
                    ></span>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card class="mx-auto">
                  <v-card-title>
                    <p class="subtitle-1 mb-0">Not Answer</p>
                    <v-spacer></v-spacer>
                    <span
                      :class="`headline font-weight-bold orange--text`"
                      v-text="this.arrReportQuiz[0].notAnswer"
                    ></span>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
            <v-row
              v-for="reportChoice in arrReportQuiz"
              :key="reportChoice._id"
            >
              <v-col
                cols="12"
                class="mb-2"
                v-for="(choice, index) in reportChoice.quizChoice"
                :key="choice._id"
              >
                <v-row class="px-3">
                  <p class="title font-weight-bold mb-0 mr-2">
                    {{ index + 1 }}. {{ choice.text }}
                  </p>
                  <span>
                    <v-card flat tile>
                      <v-img
                        :src="choice.image == null ? imageReady1 : choice.image"
                        :lazy-src="choice.image"
                        aspect-ratio="1"
                        height="50"
                        width="50"
                      >
                        <template v-slot:placeholder>
                          <v-row class="ma-0" align="center" justify="center">
                            <v-icon v-if="imageReady1" class="mx-auto" size="50"
                              >mdi-image</v-icon
                            >
                          </v-row>
                        </template>
                      </v-img>
                    </v-card>
                  </span>
                </v-row>
                <v-row class="px-3">
                  <v-spacer></v-spacer>
                  <p class="subtitle-1 font-weight-bold mb-0">
                    {{
                      reportChoice.percentAnswer[index] > 0
                        ? reportChoice.percentAnswer[index]
                        : '0'
                    }}% (
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <a
                          @click="viewChoice(reportChoice.quizId, choice._id)"
                          v-on="on"
                        >
                          <strong
                            id="showFilePanel"
                            class="subtitle-1 font-weight-bold"
                            >{{
                              reportChoice.countAnswer[index].countAnswer
                            }}
                            Answered</strong
                          >
                        </a>
                      </template>
                      <span class="subtitle-1">ดูสถิติ</span> </v-tooltip
                    >)
                  </p>
                  <v-progress-linear
                    :color="
                      reportChoice.quizChoiceCorrect[0] ==
                      reportChoice.quizChoice[index]._id
                        ? 'success'
                        : 'error'
                    "
                    height="20"
                    :value="
                      reportChoice.percentAnswer[index] > 0
                        ? reportChoice.percentAnswer[index]
                        : '0'
                    "
                  ></v-progress-linear>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card class="notification-container dismiss">
          <v-toolbar flat class="mb-0">
            <a @click="goBack">
              <v-list-item>
                <v-img
                  src="@/assets/icon/bacck.png"
                  lazy-src="@/assets/icon/bacck.png"
                  max-width="20"
                ></v-img>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-btn text color="primary">Back</v-btn>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </a>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="closeDialogReport">Close</v-btn>
          </v-toolbar>
          <v-card-text>
            <div class="q-report">
              <v-row>
                <v-col
                  cols="12"
                  class="mb-0"
                  v-for="(reportAnswer, index) in arrReportChoice"
                  :key="reportAnswer._id"
                >
                  <v-row class="px-3">
                    <v-list-item three-line>
                      <v-list-item-icon>
                        <p class="headline my-3 ml-3 mr-2z">
                          {{
                            paramsChoice.limit * (pageNumberChoice - 1) +
                            (index + 1)
                          }}
                        </p>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="title mb-0 mr-2">{{
                          reportAnswer.created_by
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          reportAnswer.email
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-chip
                        class="ma-2"
                        color="#FF8F03"
                        label
                        text-color="white"
                        >{{ reportAnswer.timeUse + ' ' }} sec</v-chip
                      >
                    </v-list-item>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <div class="align-position">
            <v-divider></v-divider>
            <v-card-actions>
              <v-row justify="center">
                <v-pagination
                  v-model="paramsChoice.page"
                  :length="pageCountChoice"
                  @input="changePageChoice"
                ></v-pagination>
              </v-row>
            </v-card-actions>
          </div>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogViewLeaderBoard"
      persistent
      max-width="600"
      class="overflowY"
    >
      <v-card>
        <v-toolbar flat class="mb-0">
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialogViewLeaderBoard = false"
            >Close</v-btn
          >
        </v-toolbar>
        <v-card-text>
          <div class="q-report">
            <v-row
              v-for="reportLeader in arrReportLeaderBoard"
              :key="reportLeader._id"
            >
              <v-col cols="4">
                <v-card color="#308ab7" dark tile class="mx-auto text-right">
                  <v-card-title>
                    <p class="title font-weight-light mb-0">Candidates</p>
                  </v-card-title>
                  <p class="subtitle-1 font-weight-light pb-3 mr-3">
                    {{ reportLeader.allStudentLearner }} students
                  </p>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card color="#308ab7" dark tile class="mx-auto text-right">
                  <v-card-title>
                    <p class="title font-weight-light mb-0">Full Marks</p>
                  </v-card-title>
                  <p class="subtitle-1 font-weight-light pb-3 mr-3">
                    {{ reportLeader.maxScore }} Point
                  </p>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card color="#308ab7" dark tile class="mx-auto text-right">
                  <v-card-title>
                    <p class="title font-weight-light mb-0">Questions</p>
                  </v-card-title>
                  <p class="subtitle-1 font-weight-light pb-3 mr-3">
                    {{ reportLeader.quizAll }} Question
                  </p>
                </v-card>
              </v-col>
            </v-row>
            <v-row
              v-for="(leaderBoard, index) in arrlistScore"
              :key="leaderBoard._id"
            >
              <v-col cols="12" class="mb-0 py-1">
                <!-- <v-row class="px-3"> -->
                <v-list-item three-line>
                  <v-list-item-icon>
                    <v-img
                      v-if="
                        pageLimitLeaderBoard * (pageLeaderBoard - 1) + (index + 1) == 1
                      "
                      src="@/assets/icon/gold_coin.png"
                      lazy-src="@/assets/icon/gold_coin.png"
                      max-width="34"
                    ></v-img>
                    <p v-else class="headline my-3 ml-3 mr-2z">
                      {{ pageLimitLeaderBoard * (pageLeaderBoard - 1) + (index + 1) }}
                    </p>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="title mb-0 mr-2">{{
                      leaderBoard.displayName
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      leaderBoard.email
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-chip
                    class="pa-2 text-center"
                    color="#FF8F03"
                    large
                    label
                    text-color="white"
                  >
                    <label>
                      {{ leaderBoard.score }} Point
                      <br />
                      <p class="caption mb-0 text-center">
                        ({{
                          leaderBoard.timeUseMin.toFixed(0) +
                          ' min ' +
                          leaderBoard.timeUseSec.toFixed(2) +
                          ' sec'
                        }})
                      </p>
                    </label>
                  </v-chip>
                </v-list-item>
                <!-- </v-row> -->
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <!-- <div class="align-position"> -->
        <v-divider></v-divider>
        <v-card-actions>
          <v-row justify="center ma-0">
            <v-pagination
              v-model="pageLeaderBoard"
              :length="pageCount"
              @input="changePage"
            ></v-pagination>
          </v-row>
        </v-card-actions>
        <!-- </div> -->
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddQuestion" scrollable max-width="900" persistent>
      <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
        <v-card tile>
          <v-toolbar flat dark color="primary">
            <v-toolbar-title>{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.editAddQuestion'
              )
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn icon dark @click="closeDialog" v-on="on">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="subtitle-1">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.close'
                )
              }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
              <p class="body-1 font-weight-bold mb-3">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.question'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-row>
                <v-col>
                  <v-textarea
                    v-model="questionText"
                    name="input-7-4"
                    solo
                    hide-details="auto"
                  ></v-textarea>
                </v-col>
              </v-row>
              
              <v-row>
                <v-col>
                  <div class="body-1 font-weight-bold mb-3">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.pictureForQuestion'
                        )
                      }}
                    </div>
                </v-col>
              </v-row>

              <div
                class="img-list-preview"
                v-if="this.imgBool == true || imgPreview"
              >
                <v-row>
                  <v-col cols="4" :sm="4" :md="4" :lg="4">
                    <div class="img-panel">
                      <v-img
                        :src="imgPreview == null ? imageReady : imgPreview"
                        :lazy-src="imgPreview"
                        aspect-ratio="1"
                        contain
                        height="145px"
                      ></v-img>
                    </div>
                  </v-col>
                  <v-col cols="8" :sm="8" :md="8" :lg="8">
                    <div class="progressContainer">
                      <p class="mb-0">{{ imageName }}</p>
                      <div class="d-flex">
                        <v-progress-linear
                          class="progress"
                          reactive
                          :value="progressPercent"
                          height="10"
                        ></v-progress-linear>
                        <p class="mb-0">{{ progressPercent }}%</p>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <v-row>
                <v-col class="py-0" cols="12" lg="4">
                  <div class="upload-btn-wrapper">
                    <button class="btn-choose body-1 font-weight-medium">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.chooseFile'
                        )
                      }}
                    </button>
                    <input
                      type="file"
                      accept="image/*"
                      name="myfile"
                      @change="preview"
                    />
                  </div>
                </v-col>
              </v-row>

            <v-row>
              <v-col lg="6" cols="12">
                <p class="body-1 font-weight-bold mb-3">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.score'
                    )
                  }}
                </p>
                <v-text-field
                  v-model="question_score"
                  :rules="scoreRules"
                  min="0"
                  type="number"
                  @change="checkMinScore"
                  outlined
                  required
                ></v-text-field>
              </v-col>
              <v-col lg="6" cols="12">
                <p class="body-1 font-weight-bold mb-3">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.timer'
                    )
                  }}
                </p>
                <div class="d-flex">
                  <v-text-field
                    class="mr-5"
                    v-model="mins"
                    :rules="minuteRules"
                    type="number"
                    min="0"
                    max="60"
                    @change="checkMinMins"
                    outlined
                    required
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.liveStep.addLiveDialog.minute'
                      )
                    "
                  ></v-text-field>
                  <v-text-field
                    v-model="secs"
                    :rules="secondRules"
                    type="number"
                    min="0"
                    max="60"
                    @change="checkMinSecs"
                    outlined
                    required
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.liveStep.addLiveDialog.second'
                      )
                    "
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
            <p class="body-1 font-weight-bold mb-3">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.answerType'
                )
              }}
            </p>
            <v-radio-group v-model="radioType" row>
              <v-radio
                :label="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.answerText'
                  )
                "
                value="text"
                class="mr-md-12"
                @change="typeChoice('text')"
              ></v-radio>
              <v-radio
                :label="
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.answerImage'
                  )
                "
                value="image"
                @change="typeChoice('image')"
              ></v-radio>
            </v-radio-group>
            <div class="answer-text" v-if="type == 'image'">
              <v-card elevation="0" class="">
                <p class="mb-5">
                  <span class="red--text">*</span
                  >{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.remark'
                    )
                  }}
                </p>
                  <v-radio-group v-model="answer_correct">
                <div
                  v-for="(src, index) in answer"
                  :key="index + '_quiz_dialog'"
                >
                    <v-row>
                      <v-col cols="1" class="position-radio">
                        <div class="py-5 mr-0">
                          <v-radio :value="index"></v-radio>
                        </div>
                      </v-col>
                      <v-col cols="11">
                        <v-row class="d-flex">
                          <v-col lg="3">
                            <div class="img-panel">
                              <v-img
                                :src="answer[index].image"
                                :lazy-src="answer[index].image"
                                aspect-ratio="1"
                                contain
                                height="145px"
                              ></v-img>
                            </div>
                          </v-col>
                          <v-col lg="9">
                            <div class="progressContainer">
                              <div class="d-flex">
                                <p class="mb-0">
                                  {{ answer[index].fileName }}
                                </p>
                                <div class="ml-auto text-rigth">
                                  <v-btn
                                    icon
                                    small
                                    @click="removeRow(index)"
                                    :disabled="answer.length <= 1"
                                  >
                                    <v-icon>mdi-close-circle-outline</v-icon>
                                  </v-btn>
                                </div>
                              </div>
                              <div class="d-flex">
                                <v-progress-linear
                                  class="progress"
                                  :value="answer[index].progressPercent"
                                  height="10"
                                  reactive
                                ></v-progress-linear>
                                <p class="mb-0">
                                  {{
                                    answer[index].progressPercent
                                      ? answer[index].progressPercent
                                      : 0
                                  }}%
                                </p>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                </div>
                  </v-radio-group>
              </v-card>
              <v-card
                class="px-5 pt-5 pb-0"
                elevation="0"
                color="grey lighten-5"
              >
                <p class="body-1 font-weight-medium mb-0">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.uploadImageAswer'
                    )
                  }}
                </p>
                <v-row>
                  <v-col cols="12" lg="4">
                    <div class="upload-btn-wrapper">
                      <button class="btn-choose body-1 font-weight-medium">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.liveStep.addLiveDialog.chooseFile'
                          )
                        }}
                      </button>
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        @change="previewImgChoice"
                      />
                    </div>
                  </v-col>
                  
                </v-row>
              </v-card>
            </div>
            <div class="answer-text" v-if="type != 'image'">
              <v-card elevation="0" class="">
                <p class="mb-5">
                  <span class="red--text mr-2">*</span
                  >{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.remark'
                    )
                  }}
                </p>
                  <v-radio-group v-model="answer_correct" :mandatory="false">
                <div
                  v-for="(row, index) in answer"
                  :key="index + '_quiz_dialog'"
                >
                    <v-row>
                      <v-col cols="1" class="py-0">
                        <div class="py-2">
                          <v-radio :value="index"></v-radio>
                        </div>
                      </v-col>
                      <v-col cols="10" class="py-0">
                        <v-text-field
                          v-model="answer[index].text"
                          :value="answer[index].text"
                          outlined
                          required
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1" class="py-0">
                        <div class="py-1 text-center">
                          <v-tooltip left>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                v-on="on"
                                color="error"
                                @click="removeRow(index)"
                                :disabled="answer.length <= 1"
                              >
                                <v-icon>mdi-trash-can</v-icon>
                              </v-btn>
                            </template>
                            <span class="subtitle-1">{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.liveStep.addLiveDialog.deleteAnswer'
                              )
                            }}</span>
                          </v-tooltip>
                        </div>
                      </v-col>
                    </v-row>
                </div>
                  </v-radio-group>
              </v-card>
                <v-row>
                  <v-col class="text-right">
                    <v-btn
                      class="mx-2"
                      color="primary"
                      @click="addRowAnswer"
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.addAnswer'
                        )
                      }}</v-btn
                    >
                  </v-col>
                </v-row>
            </div>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
          <v-row>
            <v-col class="text-right">
              <v-btn
                class="mx-2"
                color="blue-grey"
                outlined
                @click="closeDialog"
                >{{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
                  )
                }}</v-btn
              >
              <v-btn
                class="mx-2"
                color="primary"
                :disabled="!validationForm()"
                @click="validate"
                :loading="loadingBtn"
              >
                <v-icon left>mdi-check</v-icon
                >{{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.save'
                  )
                }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialogSwipe" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.confirmAnswerType'
          )
        }}</v-card-title>
        <v-card-text class="subtitle-1">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.msg1'
            )
          }}
          <br />{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.msg2'
            )
          }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2 title"
            large
            dark
            rounded
            outlined
            @click="cancelSwipe"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
              )
            }}</v-btn
          >
          <v-btn
            color="error darken-1"
            class="px-10 ma-2 title"
            large
            dark
            rounded
            @click="resetQuestion(tempType)"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.confirm'
              )
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUpdateSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.saveSuccess'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.saveSuccessInfo'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="closeDialog">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.done'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.confirmDelete'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.confirmDeleteInfo'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2 font-weight-light"
            dark
            outlined
            @click="dialogDelete = false"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
              )
            }}</v-btn
          >
          <v-btn
            class="px-10 ma-2 font-weight-light"
            color="error darken-1"
            dark
            @click="deleteQuiz"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.confirm'
              )
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ListStudentAnswerDialog :isDialogOpen.sync="listStudentAnsStatus" :liveId.sync="liveId" :quizId.sync="quizStudentId" :choiceId.sync="choiceStudentId" :closeDialog.sync="closeListStudentAnsDialog"/>
  </div>
</template>

<script>
import {
  getListQuiz,
  insertQuiz,
  updateQuiz,
  deleteQuiz,
  insertChoice,
  updateChoice,
  deleteAns,
  getListQuizReport,
} from '@/service/course/livev2.js';
import { headersWithTokenForImage, domain } from '@/service/configApi';
import axios from 'axios';
import {
  sendQuiz,
  reportQuiz,
  reportChoice,
  reportLeaderBoard,
  getQuiz,
} from '@/service/course/livev2';

import ListStudentAnswerDialog from '@/components/live/dialog/dialogListAnswer.vue';
import $ from 'jquery';

export default {
  props: {
    liveId: {
      type: String,
    },
  },
  components: {
    ListStudentAnswerDialog
  },
  data() {
    return {
      expandId: null,
      sizePerPage: 5,
      deletedAns: [],
      questionCurrPage: 1,
      questionReportCurrPage: 1,
      arrQuestion: [],
      arrQuestionReport: [],
      polls: [],
      dialogDelay: false,
      secondItem: [
        '10 วินาที',
        '20 วินาที',
        '30 วินาที',
        '40 วินาที',
        '50 วินาที',
        '60 วินาที',
      ],
      timeDelay: 0,
      idLiveStream: this.liveId,
      idQuiz: '',
      editId: '',
      milliSecs: 0,
      mins: 0,
      secs: 30,
      tempMins: 0,
      tempSecs: 0,
      indexQuestion: null,
      arrHisSendQuiz: [],
      dialogViewReport: false,
      dialogViewLeaderBoard: false,
      dialogSwipe: false,
      dialogDelete: false,
      dialogDeleteSuccess: false,
      dialogUpdateSuccess: false,
      dialogAddQuestion: false,
      dialogDuplicateSuccess: false,
      setbool: false,

      arrReportQuiz: [
        {
          livestreamID: this.liveId,
          countAllSeeQuiz: 0,
          countAnswer: 0,
          countQuiz: 0,
          percentAnswer: [],
          quizId: '',
          quizQuestion: '',
          quizImgQuestion: '',
          quizChoice: [
            {
              text: '',
              image: '',
            },
          ],
          quizChoiceCorrect: 0,
          notAnswer: 0,
        },
      ],
      arrReportChoice: [],
      arrReportLeaderBoard: [
        {
          allStudentLearner: 0,
          maxScore: 0,
          quizAll: 0,
        },
      ],
      questionNumber: null,
      imageReady: false,
      imgBool: false,
      imageReady1: false,
      idChoice: '',

      imgPreview1: '',
      imgPreviewChoice: [{ preview: '' }],
      imageFile: null,
      imageFileChoice: null,
      type: 'text',
      edit: null,
      choiceCheck: '',
      choiceText: '',
      questionText: '',
      answerImage: '',
      answer_correct: 0,
      question_score: 1,
      answer: [],
      imgPreview: '',

      pageCount: 1,
      page: 1,
      pageNumber: 1,
      pageNumberChoice: 1,
      paramsBoard: {},
      pageCountChoice: 1,
      pageChoice: 1,
      paramsChoice: {},
      tab: null,
      text:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      slug: '',
      data: [],
      deleteId: null,

      pageLeaderBoard: 1,
      pageLimitLeaderBoard: 5,

      listStudentAnsStatus: false,
      listStudent: [],
      choiceStudentId: null,
      quizStudentId: null,
      loadingBtn: false,
    };
  },
  async mounted() {
    await this.initialize();
  },
  computed: {
    scoreRules: [
      (v) =>
        !!v > 0 ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.liveStep.addLiveDialog.scoreRules'
        ),
    ],
    minuteRules: [
      (v) =>
        !!v >= 0 ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.liveStep.addLiveDialog.minuteRules'
        ),
    ],
    secondRules: [
      (v) =>
        !!v >= 0 ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.liveStep.addLiveDialog.secondRules'
        ),
    ],
    listQuestion() {
      const start = (this.questionCurrPage - 1) * this.sizePerPage,
        end = start + this.sizePerPage;
      let data = this.arrQuestion;
      return data.slice(start, end);
    },
    listQuestionReport() {
      const start = (this.questionReportCurrPage - 1) * this.sizePerPage,
        end = start + this.sizePerPage;
      let data = this.arrQuestionReport;
      return data.slice(start, end);
    },
    totalQuestionPage() {
      let l = this.arrQuestion.length,
        s = this.sizePerPage;
      return Math.ceil(l / s);
    },
    totalQuestionReportPage() {
      let l = this.arrQuestionReport.length,
        s = this.sizePerPage;
      return Math.ceil(l / s);
    },
  },
  methods: {
    async initialize() {
      this.getQuestionList();
    },
    validationForm() {
      // let bool = true;

      // this.answer.forEach((item) => {
      //   if (item.length < 1 || (item.text == '' && item.image == '')) {
      //     bool = false;
      //   }
      // });
      // if (this.mins >= 0 || this.secs >= 0) {
      //   this.valid = true;
      // }

      //
      let bool = true;
      if (this.answer.length == 0) {
        bool = false;
      }
      if (this.questionText == '') {
        bool = false;
      }
      this.answer.forEach((item) => {
        if (item.length < 1 || (item.text == '' && item.image == '')) {
          bool = false;
        }
      });
      if (this.mins >= 0 || this.secs >= 0) {
        this.valid = true;
      }
      return this.valid && bool;
    },
    async editQuestion(qId) {
      this.dialogAddQuestion = true;
      // this.edit = index;
      this.editId = qId;
      let tempMin = null;
      let tempSec = null;
      // if (this.mins >= 0 || this.secs >= 0) {
      //   this.$refs.form.resetValidation();
      // }
      if (qId) {
        let quizDetail = await getQuiz(this.liveId, qId);

        tempMin = quizDetail.time / 1000 / 60;
        tempSec = (quizDetail.time / 1000) % 60;
        this.mins = parseInt(tempMin);
        this.secs = tempSec;
        this.questionText = quizDetail.question;
        this.imgPreview = quizDetail.imageQuestion;
        if (this.imgPreview) {
          this.imgBool = true;
          this.imageReady = true;
        }

        this.question_score = quizDetail.score;
        this.answer = quizDetail.choices;
        this.imageReady1 = true;
        this.answer_correct = quizDetail.correct[0];
        this.choiceCheck = quizDetail.correct[0];

        this.answer.forEach((value, index) => {
          if (this.answer_correct === value._id) {
            this.answer_correct = index;
          }
        });

        if (
          quizDetail.choices[0].text == '' ||
          quizDetail.choices[0].text == null
        ) {
          this.type = 'image';
        }
        if (
          quizDetail.choices[0].image == '' ||
          quizDetail.choices[0].image == null
        ) {
          this.type = 'text';
        }
      } else {
        this.answer_correct = 0
        this.answer.push({ text: '' });
      }
      this.radioType = this.type;
    },

    async validate() {
      this.loadingBtn = true
      if (this.$refs.form.validate()) {
        let arrChoiceId = [];
        let choiceCorrect = [];

        if (this.mins == 0 && this.secs == 0) {
          return;
        }

        if (this.imageFile != null) {
          await this.uploadImg(this.imageFile);
        }

        if (this.type == 'image') {
          // this.answer.forEach(async (choice, index) => {
          //   if (choice._id) {
          //   } else {
          //     await this.uploadImgChoice(index, choice.file);
          //   }
          // });
          for(let [index, choice] of this.answer.entries()){
            if (choice._id) {
              console.log(choice._id);
            } else {
              await this.uploadImgChoice(index, choice.file);
            }
          }
        }

        if (this.mins >= 0 || this.secs >= 0) {
          this.$refs.form.resetValidation();
        }

        let milliSec = this.secs * 1000;
        let milliMin = this.mins * 60000;
        let timeLimited = milliMin + milliSec;

        let question = {
          priority: await this.findMaxPriorityInQuiz(),
          question: this.questionText,
          imageQuestion: this.imgPreview,
          score: this.question_score,
          time: timeLimited,
        };
        let resultQuestion = null;

        if (!this.editId) {
          resultQuestion = await insertQuiz(this.liveId, question);
          if (!resultQuestion.code) {
            this.editId = resultQuestion;
          } else {
            return;
          }
        }

        //#region answer
        for (var i = 0; i < this.answer.length; i++) {
          if (this.answer[i]._id) {
            let result = await updateChoice(
              this.liveId,
              this.editId,
              this.answer[i]._id,
              {
                text: this.answer[i].text,
                image: this.answer[i].image,
              }
            );
            await arrChoiceId.push(this.answer[i]._id);
          } else {
            let result = await insertChoice(this.liveId, this.editId, {
              text: this.answer[i].text,
              image: this.answer[i].image,
            });
            await arrChoiceId.push(result);
          }
        }

        for (let quiz of this.deletedAns) {
          await deleteAns(this.liveId, this.editId, quiz);
        }
        //#endregion

        let updateQuizResult = null;
        if (arrChoiceId) {
          updateQuizResult = await updateQuiz(this.liveId, this.editId, {
            ...question,
            correct: [arrChoiceId[this.answer_correct]],
          });
        }
        if (!updateQuizResult.code) {
          await this.successInsertAndUpdate();
        }
      }
      this.loadingBtn = false
    },

    findMaxPriorityInQuiz() {
      let minValue = 0;
      let maxReportPriority = 0;
      let maxQuestionPriority = 0;
      let sizeOfQuestionReport = this.arrQuestionReport.length;
      if (sizeOfQuestionReport > 0) {
        maxReportPriority = this.arrQuestionReport[sizeOfQuestionReport - 1]
          .priority;
      }
      let sizeOfQuestion = this.arrQuestion.length;
      if (sizeOfQuestion > 0) {
        maxQuestionPriority = this.arrQuestion[sizeOfQuestion - 1].priority;
      }
      return Math.max(minValue, maxReportPriority, maxQuestionPriority);
    },

    successInsertAndUpdate() {
      this.dialogUpdateSuccess = true;
      this.dialogAddQuestion = false;
      this.edit = null;
      this.editId = '';
      this.type = 'text';
      this.questionText = '';
      this.imgPreview = '';
      this.imgPreviewChoice = [{ preview: '' }];
      this.imageFileChoice = null;
      this.imageReady = false;
      this.imageReady1 = false;
      this.question_score = 1;
      this.mins = 0;
      this.secs = 0;
      this.answer = [];
      this.setbool = false;
      this.newQuestion = false;
      this.deletedAns = [];
      this.answer_correct = 0
      this.$refs.form.resetValidation();
      // this.getQuestionList();
    },

    async changePage(page) {
      this.pageLeaderBoard = page;
      await this.getReportLeaderBoard();
    },
    async changePageChoice(page) {
      this.pageChoice = page;
      await this.getReportChoice();
    },
    typeChoice(type) {
      this.tempType = type;
      this.dialogSwipe = true;
    },
    closeDialog() {
      this.dialogAddQuestion = false;
      this.dialogUpdateSuccess = false;
      this.dialogDuplicateSuccess = false;
      this.dialogDeleteSuccess = false;
      this.newQuestion = false;
      this.edit = null;

      this.setbool = false;
      this.questionText = '';
      this.imgPreview = '';
      this.imgPreview1 = '';
      this.imgPreviewChoice = [{ preview: '' }];
      this.imageFileChoice = null;
      this.imageReady = false;
      this.question_score = 1;
      this.mins = 0;
      this.secs = 30;
      this.answer = [];
      this.editId = '';
      this.type = 'text';

      this.imageFile = null;
      this.imgPreview = '';
      this.imageName = '';
      this.progressPercent = 0;
      this.imgBool = false;

      this.percent = [];
      this.imgSrc = [];
      this.imgFile = [];
      this.deletedAns = [];
      this.getQuestionList();

      this.$refs.form.resetValidation();
    },

    resetQuestion(type) {
      switch (type) {
        case 'text':
          this.type = 'text';
          this.percent = [];
          this.imgSrc = [];
          this.imgFile = [];
          this.question_score = 1;
          this.mins = 0;
          this.secs = 30;
          this.answer = [];
          this.answer.push({ text: '' });
          this.dialogSwipe = false;
          break;
        case 'image':
          this.type = 'image';
          this.percent = [];
          this.imgSrc = [];
          this.imgFile = [];
          this.question_score = 1;
          this.mins = 0;
          this.secs = 30;
          this.answer = [];
          this.dialogSwipe = false;
          break;
        default:
          break;
      }
    },
    cancelSwipe() {
      switch (this.tempType) {
        case 'text':
          this.radioType = 'image';
          this.dialogSwipe = false;
          break;
        case 'image':
          this.radioType = 'text';
          this.dialogSwipe = false;
          break;
        default:
          break;
      }
    },
    choiceCheckAnswer(choice) {
      this.choiceCheck = choice;
    },
    async deleteQuiz() {
      await deleteQuiz(this.liveId, this.deleteId);
      this.dialogDelete = false;
      this.deleteId = null;
      // this.dialogDeleteSuccess = true;
      // this.arrQuestion = [];
      await this.getQuestionList();
    },
    addRowAnswer: function () {
      if (this.type == 'text') {
        this.answer.push({ text: '' });
      } else {
        this.answer.push({ image: this.answerImage });
        this.answerImage = '';
      }
    },
    removeRow: function (index) {
      // this.rows.$remove(index);
      if (this.answer.length > 1) {
        if (this.answer_correct === index) {
          this.answer_correct = 0;
        } else if (this.answer_correct > index) {
          this.answer_correct = this.answer_correct - 1;
        }
        if (this.answer[index]._id) {
          this.deletedAns.push(this.answer[index]._id);
        }
        this.answer.splice(index, 1);
      }
    },
    async uploadImg(file) {
      // let status = await uploadImage("question", image);
      // return status;
      this.showUploadPercent = true;

      let formData = new FormData();
      formData.append('fileupload', file);
      formData.append('title', file.name);
      await axios
        .post(`${domain}/uploadfile/public/image/question`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            this.imgPreview = response.data.result;
          }.bind(this)
        )
        .catch(function (e) {
        });
    },

    async uploadImgChoice(index, file) {
      let formData = new FormData();
      formData.append('fileupload', file);
      // formData.append("title", file.name);

      await axios
        .post(`${domain}/uploadfile/public/image/question`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            let progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
            this.updateProgress(index, progressPercent);
          }.bind(this),
        })
        .then(
          async function (response) {
            this.answer[index].image = await response.data.result;
          }.bind(this)
        )
        .catch(function (e) {
        });
    },

    async preview(event) {
      let file = event.target.files[0];

      this.imageFile = file;
      this.imgPreview = await URL.createObjectURL(file);
      this.imageName = file.name;
      this.imgBool = true;
    },

    async previewImgChoice(event) {
      let totalFiles = event.target.files.length;
      for (var i = 0; i < totalFiles; i++) {
        let file = event.target.files[i];
        // this.imgFile.push(file);

        // this.imgSrc.push({
        //   name: file.name,
        //   src: await URL.createObjectURL(file),
        //   progressPercent: 0
        // });
        this.answer.push({
          image: await URL.createObjectURL(file),
          progressPercent: 0,
          file: file,
          fileName: file.name,
        });
      }
    },
    updateProgress(index, percent) {
      this.answer[index].progressPercent = percent;
    },
    checkMinMins() {
      if (this.mins < 0) {
        this.mins = 0;
      } else if (this.mins >= 60) {
        this.mins = 59;
      }
      this.mins = Math.floor(this.mins);
    },
    checkMinSecs() {
      if (this.secs < 0) {
        this.secs = 0;
      } else if (this.secs >= 60) {
        this.secs = 59;
      }
      this.secs = Math.floor(this.secs);
    },
    viewChoice(idQuiz, idChoice) {
      this.idQuiz = idQuiz;
      this.idChoice = idChoice;
      this.getReportChoice();
    },
    closeDialogReport() {
      this.dialogViewReport = false;
      this.goBack();
    },
    goBack() {
      this.setbool = false;
      if ($('.notification-container').hasClass('selected')) {
        $('.notification-container')
          .removeClass('selected')
          .addClass('dismiss');
      }
    },
    viewReport(id, index) {
      this.idQuiz = id;
      this.questionNumber = index;
      this.getReportQuiz();
    },

    async getReportQuiz() {
      this.params = {
        idlivestream: this.liveId,
        idquiz: this.idQuiz,
      };
      let result = await reportQuiz({
        idlivestream: this.liveId,
        idquiz: this.idQuiz,
      });
      this.arrReportQuiz = [];
      this.arrReportQuiz.push({
        livestreamID: this.liveId,
        countAllSeeQuiz: result.countAllSeeQuiz,
        countAnswer: result.countAnswer,
        countQuiz: result.countQuiz,
        percentAnswer: [],
        quizId: result.quiz._id,
        quizQuestion: result.quiz.question,
        quizImgQuestion: result.quiz.imageQuestion,
        quizChoice: result.quiz.choices,
        quizChoiceCorrect: result.quiz.correct,

        notAnswer: result.countAllSeeQuiz - result.countQuiz,
      });
      this.arrReportQuiz[0].countAnswer.forEach((value) => {
        this.arrReportQuiz[0].percentAnswer.push(
          ((value.countAnswer / this.arrReportQuiz[0].countQuiz) * 100).toFixed(
            1
          )
        );
      });
      if (this.arrReportQuiz) {
        this.dialogViewReport = true;
      }
      if (
        this.arrReportQuiz[0].quizImgQuestion == '' ||
        this.arrReportQuiz[0].quizImgQuestion == null
      ) {
        this.imageReady = true;
      }
    },
    async getReportChoice() {
      this.paramsChoice = {
        idlivestream: this.liveId,
        idquiz: this.idQuiz,
        idanswer: this.idChoice,
        page: this.pageChoice,
        limit: 5,
      };
      let result = await reportChoice(this.paramsChoice);
      this.arrReportChoice = [];
      this.pageCountChoice = result.maxPage;
      result.data.forEach((quiz) => {
        this.arrReportChoice.push({
          livestreamID: this.liveId,
          id: quiz._id,
          timeUse: (quiz.timeUse / 1000).toFixed(2),
          created_by: quiz.created_by.displayName,
          email: quiz.created_by.email,
          studentId: quiz.created_by._id,
        });
      });
      this.pageNumberChoice = this.pageChoice;
      this.setbool = true;
      if ($('.notification-container').hasClass('dismiss')) {
        $('.notification-container')
          .removeClass('dismiss')
          .addClass('selected')
          .show();
      }
    },

    async viewLeaderBoard() {
      this.dialogViewLeaderBoard = true
      await this.getReportLeaderBoard();
    },

    async getReportLeaderBoard() {
      // this.paramsBoard = {
      //   idlivestream: this.liveId,
      //   page: this.pageLeaderBoard,
      //   limit: 1,
      // };
      let offset = `${(this.pageLeaderBoard - 1) * this.pageLimitLeaderBoard},${this.pageLimitLeaderBoard}`;
      let query = {
        offset
      }
      let result = await reportLeaderBoard(this.liveId, query);
      this.arrReportLeaderBoard = [];
      this.arrlistScore = [];
      this.arrReportLeaderBoard.push({
        livestreamID: this.liveId,
        allStudentLearner: result.allStudentLearner,
        maxScore: result.maxScore,
        quizAll: result.quizAll,
      });
      this.pageCount = result.page;
      result.dataScore.forEach((list) => {
        this.arrlistScore.push({
          id: list._id,
          timeUseMin: list.timeUse / 1000 / 60,
          timeUseSec: (list.timeUse / 1000) % 60,
          score: list.totalScore,
          displayName: list.student.displayName,
          email: list.student.email,
        });
      });
      // this.pageNumber = this.page;

      this.dialogViewLeaderBoard = true;
    },

    async getQuestionList() {
      this.params = {
        idlivestream: this.liveId,
      };
      let result = await getListQuiz(this.liveId);
      let tmpArrQuestion = [];
      result.forEach((quiz) => {

        // let tmpChoice = []
        // for(let choice of quiz.choices){
        //   let foundCorrect = quiz.correct.findIndex(correct => correct === choice._id)
        //   tmpChoice.push({
        //     ...choice,
        //     correct: foundCorrect > -1 ? true : false
        //   })
        // }

        tmpArrQuestion.push({
          id: quiz._id,
          livestreamID: this.liveId,
          question: quiz.question,
          // choices: quiz.choices,
          // correctAnswer: quiz.correct,
          imageQuestion: quiz.imageQuestion,
          score: quiz.score,
          time: quiz.time,
          historySends: quiz.historySends,
          priority: quiz.priority + 1,
        });
      });

      this.arrQuestion = tmpArrQuestion;

      let tempArrQuestionReport = [];
      let resultQuizReport = await getListQuizReport(this.liveId);
      resultQuizReport.forEach((quiz) => {

        let tmpChoice = []
        for(let choice of quiz.choices){
          let foundCorrect = quiz.correct.findIndex(correct => correct === choice._id)
          tmpChoice.push({
            ...choice,
            correct: foundCorrect > -1 ? true : false
          })
        }

        tempArrQuestionReport.push({
          id: quiz._id,
          livestreamID: this.liveId,
          question: quiz.question,
          choices: tmpChoice,
          correctAnswer: quiz.correct,
          imageQuestion: quiz.imageQuestion,
          score: quiz.score,
          time: quiz.time,
          historySends: quiz.historySend,
          priority: quiz.priority + 1,
          totalAnswers: quiz.totalAnswers,
          totalParticipants: quiz.totalParticipants,
        });

      });
      this.arrQuestionReport = tempArrQuestionReport;
    },

    showTimeQuestion(id, time) {
      this.dialogDelay = true;
      this.idQuiz = id;
      this.mins = parseInt(time / 1000 / 60);
      this.secs = (time / 1000) % 60;
      this.timeDelay = time;
      this.tempMins = this.mins;
      this.tempSecs = this.secs;
    },

    sendQuizToLive() {
      this.dialogDelay = false;
      // this.secondItem.forEach((timeValue, index) => {
      //   if (this.timeDelay === timeValue) {
      //     this.milliSecs = (index + 1) * 10 * 1000;
      //   }
      // });
      this.timeDelay = this.mins * 60 * 1000 + this.secs * 1000;
      this.sendQuiz();
    },

    async sendQuiz() {
      let question = {
        delay: this.timeDelay,
      };

      await sendQuiz(this.liveId, this.idQuiz, question);
      this.getQuestionList();
    },
    expand(id) {
      this.expandId = id;
    },
    hide(id) {
      this.expandId = null;
    },
    openDeleteDialog(deleteId) {
      this.dialogDelete = true;
      this.deleteId = deleteId;
    },
    openListStudentAnsDialog(questionId, choiceId){
      this.quizStudentId = questionId
      this.choiceStudentId = choiceId
      this.listStudentAnsStatus = true
    },
    closeListStudentAnsDialog(){
      this.listStudentAnsStatus = false
    }
  },
};
</script>

<style lang="scss">
.btnLeader {
  border-radius: 0px !important;
}
.message-container {
  position: relative;
  height: 77vh;
  background-color: white;
}
.align-position {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.overflowY {
  overflow-y: inherit;
}
.message-scroll {
  height: 80vh;
  overflow: hidden;
}
.v-dialog .v-dialog--active {
  overflow: inherit;
}
.notification-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  display: none;
  height: 100%;
  overflow: hidden;
  background: #ebdbbf;
  z-index: 999;
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
}

.selected {
  animation: slide-in 0.3s forwards;
  -webkit-animation: slide-in 0.3s forwards;
}

.dismiss {
  animation: slide-out 0.3s forwards;
  -webkit-animation: slide-out 0.3s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}

@keyframes slide-out {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@-webkit-keyframes slide-out {
  0% {
    -webkit-transform: translateX(0%);
  }
  100% {
    -webkit-transform: translateX(100%);
  }
}
.q-detail {
  height: 610px;
  overflow-y: scroll;
}
.q-report {
  height: 620px;
}
.overflow-hd {
  overflow-x: hidden !important;
}
.page-card {
  border-radius: 0px !important;
  transition: transform 0.3s ease-in-out;
}

.datetime {
  padding: 15px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  text-align: center;
  transition: box-shadow 0.3s ease-in-out;
}

.datetime:hover {
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.selectCourse {
  height: auto;
  border: 0px;
  padding: 15px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  text-align: center;
  transition: box-shadow 0.3s ease-in-out;
}

.selectCourse:hover {
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.progress-bar {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 0.9);
}

.card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.option {
  transition: transform 0.3s ease-in-out;
  color: white;
  .tab-live-detail {
    &.v-tab--active {
      border: 0;
      background: #ff8f03;
    }
  }
}

.option-content {
  transition: transform 0.3s ease-in-out;
  background: white;
  border-bottom: 1px solid #eeeeef;
  border-left: 1px solid #eeeeef;
  border-right: 1px solid #eeeeef;
}
.message-detail {
  height: 85%;
  overflow-y: scroll;
  padding-top: 15px;
}
.content {
  border-radius: 10px;
  transition: transform 0.3s ease-in-out;
  background-color: #efefef;
}

.button {
  // box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  // border-radius: 5px;
  transition: transform 0.3s ease-in-out;
  background-color: #50adde;
  color: white;
  height: 35px;
}
.cardQ {
  padding-top: 5px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 12px;
}

.button:hover {
  transform: scale(0.95, 0.95);
}

.right-nav {
  transition: transform 0.3s ease-in-out;
  color: #9d9d9d;
  margin: 0;
  padding: 10px 0;
  .v-image {
    filter: grayscale(1);
    width: 50px;
  }
  i {
    color: inherit !important;
  }
  &.active {
    color: #ff8f03;
    background: white;
    .v-image {
      filter: none;
    }
  }
  &:hover {
    background: white;
    cursor: pointer;
  }
}
.v-tabs:not(.v-tabs--vertical) .v-tab {
  flex-grow: 1;
  border-right-style: solid;
  border-right-width: thin;
  border-right-color: #eeeeef;
}

.live-preview {
  background: rgba(0, 0, 0, 0.8);
  height: 500px;
  width: 100%;
  transition: transform 0.3s ease-in-out;
}

.live-detail {
  transition: transform 0.3s ease-in-out;
  background-image: linear-gradient(rgba(#0779e4, 0.7), rgba(#0779e4, 0.9));
  border-style: solid;
  border-width: thin;
  border-color: #eeeeef;
  border-right: unset;
  border-radius: 3px;
}

.live-detail-content {
  transition: transform 0.3s ease-in-out;
  background-color: rgba(0, 0, 0, 0.09);
  border-top-style: solid;
  border-top-width: thin;
  border-top-color: #eeeeef;
  border-right-style: solid;
  border-right-width: thin;
  border-right-color: #eeeeef;
}

.card-top {
  background-image: linear-gradient(rgba(#0779e4, 1), rgba(#0779e4, 0.7));
  color: white;
}

.card-navigation {
  background-image: linear-gradient(rgba(#0779e4, 0.7), rgba(#0779e4, 0.4));
  color: white;
}

.card-corner {
  background-image: linear-gradient(rgba(#4cbbb9, 0.8), rgba(#4cbbb9, 0.5));
  color: white;
}

.card-right {
  background-image: linear-gradient(rgba(#084177, 0.5), rgba(#084177, 0.3));
  color: white;
}

.videoPlayer {
  width: 100%;
}

.graph-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.graph-card:hover {
  transform: scale(1.02, 1.02);
}
.full-width {
  width: 96%;
}
.header-option {
  background: #308ab7;
  color: white;
}
.tab-header-option {
  background: white;
  color: #000000;
  font-size: 20px !important;
}
.menu-title {
  padding-top: 10px;
  padding-bottom: 20px;
  padding-right: 10px;
  padding-left: 10px;
}
.divQ {
  padding-top: 10px;
  padding-bottom: 5px;
  padding-right: 10px;
  padding-left: 10px;
}
.v-tabs-slider-wrapper {
  height: 0px !important;
}
.player-container {
  background-color: white;
}
.chat-container {
  // position: absolute;
  // right: 0;
  // height: 100vh;
}
.tab-subtitle-2 {
  font-size: 16px !important;
  color: #4a4a4a;
  margin-bottom: 20px;
}
.tab-header-container {
  padding: 14px;
  height: 53px;
}
.tab-header-text {
  font-size: 16px !important;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.tab-header-option-text {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}
.question-list-container {
  box-shadow: 0 1px 0 0 #dcdcdc;
  background-color: #ffffff;
  border-radius: 2px;
  border: solid 1px #dcdcdc;
}
.question-detail {
  padding: 20px;
  font-size: 14px;
  line-break: anywhere;
}
.question-no {
  font-weight: bold;
  color: #4a90e2;
}
.question-list-text {
  color: rgba(0, 0, 0, 0.85);
}
.align-right {
  margin-top: 20px;
  text-align: right;
}
.btn-edit {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: rgba(0, 0, 0, 0.65);
}
.full-btn {
  width: 100%;
}
.btn-send {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff !important;
}
.pagination-align-right {
  justify-content: flex-end;
}
.header-table-report {
  border: solid 1px #dcdcdc;
  background-color: #f5f5f5;

  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
.content-table-report {
  border: solid 1px #dcdcdc;
  background-color: #ffffff;

  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.9;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
.subcontent-table-report {
  // border: solid 1px #dcdcdc;
  // background-color: #ffffff;

  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.9;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}
.cell-table-report {
  padding: 18px;
}
.header-cell-table-report {
  padding: 18px;
}
.expand-panel-opt {
  background-color: #f3f9ff;
}
.align-center {
  align-self: center;
}
.image-center {
  margin: 0 auto;
}
.opt-ans {
  padding-top: 0px;
}
.choice-table-report {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}
.pagination-align-right.justify-flex-end {
  .v-pagination.theme--light {
    justify-content: flex-end;
  }
}
.btn-refresh {
  margin-right: 30px;
}
@media only screen and (max-width: 1024px) {
  .btn-refresh {
    margin-right: 6px;
  }
}
@media only screen and (max-width: 768px) {
  .xs-full-width {
    width: 100% !important;
    margin-bottom: 10px;
  }
}
.text-refresh {
  color: rgba(0, 0, 0, 0.65);
}
</style>
<style lang="scss">
.pagination-align-right {
  .v-pagination__item--active {
    background-color: #308ab7 !important;
    border-color: #308ab7 !important;
  }
}
.action-btn-container {
  padding-top: 21px;
}
.place-content {
  place-content: space-evenly;
}
</style>